import {ThemeIconKey} from 'platform/foundation';
import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {TestIdProps} from 'shared/web';

import {Alert} from '../../../../../components/Alert/Alert';
import i18n from '../../../../../i18n/i18n';

interface AttractivenessSituationAlertProps extends TestIdProps {
  situation?: string;
}

export function AttractivenessSituationAlert(props: AttractivenessSituationAlertProps) {
  const situation = match<
    string | undefined,
    {
      flag: string;
      description: string;
      color: 'success' | 'warning' | 'neutral';
      icon: ThemeIconKey;
    } | null
  >(props.situation)
    .with('MARKET_SITUATION_MAJOR_SHORTAGE', () => ({
      flag: i18n.t('entity.attractivenessCard.majorShortageFlag'),
      description: i18n.t('entity.attractivenessCard.majorShortageDescription'),
      color: 'success',
      icon: 'action/trending_up',
    }))
    .with('MARKET_SITUATION_SHORTAGE', () => ({
      flag: i18n.t('entity.attractivenessCard.shortageFlag'),
      description: i18n.t('entity.attractivenessCard.shortageDescription'),
      color: 'success',
      icon: 'action/trending_up',
    }))
    .with('MARKET_SITUATION_STABLE', () => ({
      flag: i18n.t('entity.attractivenessCard.stableFlag'),
      description: i18n.t('entity.attractivenessCard.stableDescription'),
      color: 'neutral',
      icon: 'action/info_outline',
    }))
    .with('MARKET_SITUATION_SURPLUS', () => ({
      flag: i18n.t('entity.attractivenessCard.surplusFlag'),
      description: i18n.t('entity.attractivenessCard.surplusDescription'),
      color: 'warning',
      icon: 'action/trending_down',
    }))
    .with('MARKET_SITUATION_MAJOR_SURPLUS', () => ({
      flag: i18n.t('entity.attractivenessCard.majorSurplusFlag'),
      description: i18n.t('entity.attractivenessCard.majorSurplusDescription'),
      color: 'warning',
      icon: 'action/trending_down',
    }))
    .otherwise(() => null);

  if (isNil(situation)) {
    return null;
  }

  return (
    <Alert variant={situation.color} icon={situation.icon} data-testid={props['data-testid']}>
      <strong>{situation.flag}</strong>: {situation.description}
    </Alert>
  );
}
